import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  Row,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"

const ComplimentaryAuthority = ({ onUpdate, onChangeSettings, settings }) => {
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      email: (settings && settings) || "",
    },
    // validationSchema: Yup.object({
    //   email: Yup.string().email("Please enter valid email address.").required("Please Enter Value"),
    // }),
    onSubmit: values => {
      if (values) {
        let modifiedData = settings
        modifiedData = values["email"]
        console.log(modifiedData)
        onChangeSettings("complimentaryAuthority", modifiedData)
      }
    },
  })

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <div className="mb-4 card-title">
            <i className="bx bxs-check-shield text-primary align-bottom font-size-24 me-2"></i>
            Complimentary Authority
          </div>
          <Form
            onSubmit={e => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            <Row>
              <Col md={12}>
                <div className="mb-3">
                  <Label className="form-label">Email*</Label>
                  <Input
                    name="email"
                    value={validation.values.email || ""}
                    type="text"
                    className="form-control form-control"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.email && validation.errors.email
                        ? true
                        : false
                    }
                  />
                  {validation.touched.email && validation.errors.email ? (
                    <FormFeedback type="invalid">
                      {validation.errors.email}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
            </Row>
            <div className="mb-3"></div>
            <div>
              <button
                type="submit"
                onClick={onUpdate}
                className="btn btn-primary w-md"
              >
                Update
              </button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

ComplimentaryAuthority.propTypes = {
  onUpdate: PropTypes.func,
  onChangeSettings: PropTypes.func,
  settings: PropTypes.any,
}
export default ComplimentaryAuthority
